import { Badge, ListGroup } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-solid-svg-icons'
import { useMunicipalityIssues } from 'api/hooks/use-municipality-issues'
import IssueCounts from './IssueCounts'

function AccessControlList() {
  const { data: issues, isSuccess } = useMunicipalityIssues({})

  const navigateToIssue = (id) => {
    window.location.href = `/issues/${id}`
  }

  return (
    <>
      <Row>
        <Col sm="auto">
          <h3>Issues</h3>
        </Col>
        <Col sm="auto">
          <div className="mt-2">
            <a href="/issues">View All</a>
          </div>
        </Col>
      </Row>
      <ListGroup variant="flush">
        {isSuccess &&
          issues.map((issue, index) => (
            <ListGroup.Item
              key={index}
              className="justify-content-between"
              action
              as="button"
              onClick={() => navigateToIssue(issue.id)}
            >
              <div>
                <Row>
                  <Col sm={12}>
                    <strong>{issue?.issue?.name}</strong>
                  </Col>
                </Row>

                <Row>
                  <Col sm="auto">
                    <IssueCounts issue={issue} />
                    {issue?.subscribed && (
                      <Badge className="bg-white border text-primary" title="Subscribed to notifications">
                        <FontAwesomeIcon icon={faBell} size="xs" className="text-primary me-1" />
                        Subscribed
                      </Badge>
                    )}
                  </Col>
                </Row>
              </div>
            </ListGroup.Item>
          ))}
      </ListGroup>
    </>
  )
}

export default AccessControlList
